import{courierShortConfigV1,createMaintainedPlatformRunEffectV1,validatePlatformRunConfigV1,
  type PlatformRunConfigV1,type PlatformRunEventV1,type PlatformRunSnapshotV1}from'./platformRun.js';
import{SHORT_BOOST_RULE_V1,validateEventRulesV1,type EventRuleStateV1,type EventRuleTransitionV1,type EventRuleV1}from'./eventRules.js';

export interface CourierBoostConfigV1 extends Omit<PlatformRunConfigV1,'profile'>{
  profile:'courier-boost@1';variant:'standard';eventRules:[EventRuleV1];
}
export interface CourierBoostSnapshotV1 extends PlatformRunSnapshotV1{
  profile:'courier-boost@1';variant:'standard';boost:EventRuleStateV1;
}
export type CourierBoostEventV1=PlatformRunEventV1|EventRuleTransitionV1;

export function courierBoostConfigV1():CourierBoostConfigV1{
  const{profile:_profile,...base}=courierShortConfigV1();
  return{profile:'courier-boost@1',variant:'standard',...base,eventRules:[structuredClone(SHORT_BOOST_RULE_V1)]};
}
function record(value:unknown,keys:readonly string[]):asserts value is Record<string,unknown>{
  if(!value||typeof value!=='object'||Array.isArray(value)||![Object.prototype,null].includes(Object.getPrototypeOf(value))
    ||Reflect.ownKeys(value).length!==keys.length||Object.keys(value).sort().join(',')!==[...keys].sort().join(',')
    ||Object.values(Object.getOwnPropertyDescriptors(value)).some(descriptor=>!('value'in descriptor)))throw new RangeError('Invalid courier-boost record');
}
export function validateCourierBoostConfigV1(input:unknown):CourierBoostConfigV1{
  record(input,['profile','variant','physics','level','rules','eventRules']);
  if(input.profile!=='courier-boost@1'||input.variant!=='standard')throw new RangeError('Unsupported courier-boost profile');
  const base=validatePlatformRunConfigV1({profile:'courier-short@1',physics:input.physics,level:input.level,rules:input.rules});
  const eventRules=validateEventRulesV1(input.eventRules);
  return{profile:'courier-boost@1',variant:'standard',physics:base.physics,level:base.level,rules:base.rules,eventRules};
}
export function createCourierBoostV1(input:CourierBoostConfigV1){
  const config=validateCourierBoostConfigV1(input);
  const base:PlatformRunConfigV1={profile:'courier-short@1',physics:config.physics,level:config.level,rules:config.rules};
  const loop=createMaintainedPlatformRunEffectV1(base,'short-boost@1');
  return{
    applyCommand:loop.applyCommand,step:loop.step,
    snapshot():CourierBoostSnapshotV1{return structuredClone({...loop.snapshot(),profile:'courier-boost@1' as const,variant:'standard' as const,boost:loop.effectSnapshot()!});},
    drainEvents():CourierBoostEventV1[]{return loop.drainEvents();},
  };
}
